var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner"},[_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"8","stroke":"#0053FF","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }